import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const MARKDOWN_COMPONENTS = {
  h1: ({ ...props }) => <h1 className="font-cinzel text-3xl text-amber-100 mt-2" {...props} />,
  h2: ({ ...props }) => <h2 className="font-cinzel text-2xl text-amber-200 mt-8" {...props} />,
  h3: ({ ...props }) => <h3 className="font-cinzel text-xl text-amber-200 mt-6" {...props} />,
  p: ({ ...props }) => <p className="text-sm sm:text-base text-zinc-300" {...props} />,
  ul: ({ ...props }) => <ul className="list-disc pl-5 space-y-2 text-zinc-300" {...props} />,
  ol: ({ ...props }) => <ol className="list-decimal pl-5 space-y-2 text-zinc-300" {...props} />,
  li: ({ ...props }) => <li className="pl-1" {...props} />,
  a: ({ ...props }) => <a className="text-amber-300 underline underline-offset-4" target="_blank" rel="noreferrer" {...props} />,
  blockquote: ({ ...props }) => <blockquote className="border-l-2 border-amber-700/50 pl-4 italic text-zinc-400" {...props} />,
  code: ({ inline, ...props }) => inline ? <code className="rounded bg-zinc-900 px-1.5 py-0.5 text-amber-200" {...props} /> : <code className="block overflow-x-auto rounded border border-zinc-800 bg-zinc-950 p-4 text-sm text-zinc-200" {...props} />,
  hr: ({ ...props }) => <hr className="border-amber-900/20" {...props} />,
};

export function WikiMarkdown({ children, dataTestId = "wiki-markdown" }) {
  return (
    <div data-testid={dataTestId} className="space-y-5 text-zinc-200 leading-7">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={MARKDOWN_COMPONENTS}>
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}